import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusDevelopmentStatus, deleteDevelopmentStatus, getAllDevelopmentStates } from "../../../../api/developmentStatus";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    buttonsStyle,
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";

export default function TechnologyPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [developmentStatus, setDevelopmentStatus] = useState(null);

    useEffect(() => {
        getAllDevelopmentStates()
            .then((res) => {
                const data = res.data.map(item => ({
                    ...item,
                    title: getNonEmpty(item.title),
                    description: getNonEmpty(item.description),
                    id: item._id,
                }))
                setData(data);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get development status.' })
            })
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item.id === cell);
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle} size="small"
                        onClick={() => history.push('/edit-developmentStatus/' + elem.id)}>
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title={elem?.active ? "Deactivate" : "Activate"}>
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setDevelopmentStatus(elem);
                                    setOpenConfirmDialog(1);
                                }}
                            >
                                {elem?.active ? (
                                    <ToggleOffIcon />
                                ) : (
                                    <ToggleOnIcon style={{ color: "red" }} />
                                )}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setDevelopmentStatus(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "id", text: "", formatter: buttonFormatter }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Development states list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-developmentStatus")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={`Are you sure you want to ${developmentStatus?.active ? "deactivate" : "activate"} this development status?`}
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            changeStatusDevelopmentStatus(developmentStatus.id, !developmentStatus?.active)
                                .then((res) => {
                                    alertSuccess({
                                        title: `${developmentStatus?.active ? "Deactivate!" : "Activate!"
                                            }`,
                                        customMessage: `Development status ${developmentStatus?.active ? "deactivate" : "activate"
                                            } successfully`,
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: `Could not ${developmentStatus?.active ? "deactivate" : "activate"
                                            } the development status.`,
                                    });
                                });
                        }}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this development status?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteDevelopmentStatus(developmentStatus.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Development status deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the development status.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}